const $ = window.jQuery;
const $window = window.$window || $(window);

const StickyHeader = {

    init() {
         var headerHeight = $('#header').outerHeight(); 

       /*  jQuery('#header').next().css('padding-top', headerHeight); */
        var scroll = $(window).scrollTop();
        const adminBar = $('#wpadminbar');

        let offset = 1;
        if (adminBar[0]) {
            offset =  adminBar.outerHeight();
        }

        if (scroll >= offset) {
    
            $("#header").addClass("state--scrolled");
         
        } else {
    
            $("#header").removeClass("state--scrolled");
          
        }

    },

 

};

export default StickyHeader;